import React, { Fragment } from 'react';
import InputField from '../../../components/inputs/inputField.js';
import ToggleField from '../../../components/inputs/toggleField.js';
import FieldModal from '../../../components/modals/fieldModal.js';

class AddAttendeeModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			firstName: '',
			lastName: '',
			email: '',
			sendInvitationEmail: false,
			submitting: false,
			invalid: false,
			error: 'All fields are required',
			contactError: null
		};
	}

	handleFNChange = (e) => {
		this.setState({
			firstName: e.target.value
		});
	};

	handleLNChange = (e) => {
		this.setState({
			lastName: e.target.value
		});
	};

	handleEAChange = (e) => {
		this.setState({
			email: e.target.value
		});
	};

	resetAdd = (e, toggle) => {
		this.setState({
			firstName: '',
			lastName: '',
			email: '',
			sendInvitationEmail: false,
			submitting: false,
			invalid: false,
			contactError: null
		});
		if (!toggle === true) this.props.toggle();
	};

	handleSubmit = async () => {
		this.setState({ submitting: true, contactError: null });

		const result = await this.props.createContact({
			email: this.state.email,
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			sendInvitationEmail: this.state.sendInvitationEmail
		});
		if (result && result.success) {
			this.resetAdd();
		} else if (result && result.error) {
			this.setState({ contactError: result.error, submitting: false });
		} else {
			this.setState({ submitting: false });
		}
	};

	render() {
		const { isOpen, requiredFields } = this.props;
		const { firstName, lastName, email, sendInvitationEmail, submitting, invalid, error } = this.state;
		return (

			<div>

				<FieldModal
					size="medium"
					isOpen={isOpen}
					modalTitle={"Add Contact"}
					bodyHeaderText={''}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div
								style={{
									overflowX: 'hidden',
									maxHeight: "calc(100vh - 400px)",
								}}
							>
								<InputField
									label="Email Address"
									value={email}
									type="email"
									required={true}
									errorTrigger={requiredFields.email || !!this.state.contactError}
									onChange={this.handleEAChange}
									errorMessage={this.state.contactError}
								/>

								<InputField
									label="First Name"
									value={firstName}
									required={true}
									type="text"
									errorTrigger={requiredFields.firstName}
									onChange={this.handleFNChange}
								/>
								<InputField label="Last Name" value={lastName} type="text" onChange={this.handleLNChange} />
								<ToggleField
									label="Send Invitation Email"
									checked={sendInvitationEmail}
									onChange={() => this.setState({ sendInvitationEmail: !sendInvitationEmail })}
									icons={false}
								/>
								{invalid && <div className="modalErrorMessage calibreRegular">{error}</div>}
							</div>)
					}}
					toggle={this.resetAdd}
					actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
					actionButton={this.handleSubmit}
					actionButtonDisabled={submitting}
				></FieldModal>

			</div>

		);
	}
}

export default AddAttendeeModal;
